import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { realTimeScoring } from '../../dbActions/realtimeScoring';
import { matchCalcs } from '../../helpers/match';
import { ammendMatchesAndTeams, getMatches_groupInfo } from './reducerHelpers/seasonSportsData';
import { sportsHelpers } from './reducerHelpers/sportsHelpers';

export const _matchSeasonalCollection = 'matches_seasonal'

const _getScoresFromScores = true

const dataItems_init = {
  sports: { parentKeys: ['organizations', 'districts', 'name'], returnFirstObject: true },
}

export const dataItems_sportsSeasonResults = {
  matches_currentSeason: {
    combineSubs: true,
    renderAs: 'matches',
    collectionName: _matchSeasonalCollection,
    ignoreCache: true,
    sportPropName: 'seasonMatches',
    collectionSubs: ['matches', 'playoffMatches', 'playoffMatches_backup', 'scores', 'playoffScores'],
    subItemKey: '_matchCollectionKey'
  },
}

export const dataItems_sportsSeasonRealtime = {
  seasonMatches: { renderAs: 'matches', collectionName: _matchSeasonalCollection, ignoreCache: true, sportPropName: 'matchInfo_seasonal', collectionSubs: ['matches', 'playoffMatches', 'playoffMatches_backup', 'scores', 'playoffScores'], subItemKey: '_matchCollectionKey' },
}

export const dataItems_sportsSeason = {
  gls_teams: { collectionName: 'gls_teams', noYear: true, noListen: true, appUsersOnly: true },
  history: { collectionName: 'history', noYear: true, noListen: true },
  rankings_seasonal: { collectionName: 'rankings_seasonal', collectionDocField: 'rankings', noListen: true },
  seasonals: { collectionName: 'seasonals', sportPropName: 'seasonals', noListen: true },
  sportsAccess_teams: { collectionName: 'sportsAccess_teams', noYear: true, noListen: true, appUsersOnly: true },
  // teamRecords: { collectionName: 'teamRecords', noListen: true, noYear: true, normalCollection: true },
  teamRosters_seasonal: { collectionName: 'teamRosters_seasonal', collectionDocField: 'teamRosters', noListen: true, sportPropName: 'teamRosters' },
  teams_seasonal: { collectionName: 'teams_seasonal', sportPropName: 'teams_seasonal', collectionDocField: 'teams', noListen: true, ignoreCache: true },
  teamStaff: { collectionName: 'teamStaff', noListen: true },
  tournaments: { collectionName: 'tournaments', noListen: true },
  mediaFeeds: { collectionName: 'mediaFeeds', sportPropName: 'mediaFeeds', noListen: true },
}

export const dataItems_matches = {
  matches_currentSeason: {
    combineSubs: true,
    renderAs: 'matches',
    collectionName: _matchSeasonalCollection,
    ignoreCache: true,
    sportPropName: 'matches_seasonal',
    collectionSubs: ['matches'],
    subItemKey: '_matchCollectionKey'
  },
}

export const dataItems_sportsSeason_small = {
  matches_seasonal: dataItems_sportsSeasonResults.matches_currentSeason,
  seasonals: { collectionName: 'seasonals', sportPropName: 'seasonals', noListen: true },
  playoffs: { collectionName: 'playoffs', sportPropName: 'playoffTemp', noListen: true },
  teams: { collectionName: 'teams', noListen: true, ignoreCache: true },
  teams_seasonal: { collectionName: 'teams_seasonal', sportPropName: 'teams_seasonal', collectionDocField: 'teams', noListen: true, ignoreCache: true },
}

export const dataItems_sportsSeason_create = {
  matches_seasonal: dataItems_matches.matches_currentSeason,
  seasonals: { collectionName: 'seasonals', sportPropName: 'seasonals', noListen: true },
  teams_seasonal: { collectionName: 'teams_seasonal', sportPropName: 'teams_seasonal', collectionDocField: 'teams', noListen: true, ignoreCache: true },
}


export const sportsDbCollections = {
  seasonal: {
    allStartNominations: 'allStartNominations',
    allStarTeams: 'allStarTeams',
    districts: 'districts',
    globals: 'globals',
    googleLinks: 'googleLinks',
    history: 'history',
    matches: 'matches',
    playoffs: 'playoffs',
    rankings: 'rankings',
    rosters: 'rosters',
    scheduleDates: 'rosters',
    schools: 'rosters',
    seasonals: 'seasonals',
    teams: 'teams',
  },
  normal: {
    athletes: 'athletes',
    districts: 'districts',
    globals: 'globals',
    organizations: 'organizations',
    schools: 'schools',
    teams: 'teams',
  }
}

export const matchUpdateTypes = {
  addConsolationMatch: 'addConsolationMatch',
  addToHistory: 'addToHistory',
  cancelMatch: 'cancelMatch',
  confirmMatchDate: 'confirmMatchDate',
  deleteMatch: 'deleteMatch',
  deleteRealtimeMatch: 'deleteRealtimeMatch',
  removeResults: 'removeResults',
  notifyMatch: 'notifyMatch',
  openDatabase: 'openDatabase',
  postponeMatch: 'postponeMatch',
  resetByeMatch: 'resetByeMatch',
  updateFullMatchDetails: 'updateFullMatchDetails',
  updateGsScore: 'updateGsScore',
  updateMatchDetails: 'updateMatchDetails',
  updateMatchListResults: 'updateMatchListResults',
  updateMatchListResultsFromGs: 'updateMatchListResultsFromGs',
  updateMatchDayMatch: 'updateMatchDayMatch',
  updatePendingMatch: 'updatePendingMatch',
  updatePrePendingMatch: 'updatePrePendingMatch',
  updateResults: 'updateResults',
  updateScore: 'updateScore',
}

export const gameScoringTypes = {
  half: 'half',
  quarter: 'quarter',
  match: 'match',
  matchPoints: 'matchPoints',
  inning: 'innning',
}

export const sectionSortingTypes = {
  sectionWinningPercentage: 'sectionWinningPercentage',
  points: 'points',
}

export const sportsShowTypes = {
  allSports: 'allSports',
  appUserCount: 'appUserCount',
  compareBoth: 'compareBoth',
  compareCommon: 'compareCommon',
  compareSections: 'compareSections', // GOOD
  compareTeams: 'compareTeams',// GOOD
  createAllPlayoffMatches: 'createAllPlayoffMatches',
  createPlayoffMatches: 'createPlayoffMatches',
  fullStandings: 'fullStandings',
  matchesRemaining: 'matchesRemaining',
  matchLocation: 'matchLocation',
  matchResults: 'matchResults', // GOOD
  pastSeasons: 'pastSeasons',
  playoffPicture: 'playoffPicture',
  realtimeMatch: 'realtimeMatch',
  teamLookup: 'teamLookup',
  updateMatch: 'updateMatch',
  updateMatchDetails: 'updateMatchDetails',
  updateResults: 'updateResults',
  viewSchedules: 'viewSchedules', // GOOD
  viewSectionGrids: 'viewSectionGrids',
}

const rts = {
  // handle_testSeason: 'handle_testSeason',
  handleAmmend_mediaMatches: 'handleAmmend_mediaMatches',
  handleAmmend_playoffQualifyCounts: 'handleAmmend_playoffQualifyCounts',
  handleAmmend_seasonMatchesFromDbResults: 'handleAmmend_seasonMatchesFromDbResults',
  handleAmmend_sportCompares: 'handleAmmend_sportCompares',
  handleAmmend_teamsAccess: 'handleAmmend_teamsAccess',
  handleDataResults_parentKeyCollections: 'handleDataResults_parentKeyCollections',
  handleFilter_sports: 'handleFilter_sports',
  handleGoTo_match: 'handleGoTo_match',
  handleGoTo_team: 'handleGoTo_team',
  handleResponse_updateMatch: 'handleResponse_updateMatch',
  handleSet_accessTeams: 'handleSet_accessTeams',
  handleSet_currentHistory: 'handleSet_currentHistory',
  handleSet_databaseCallback: 'handleSet_databaseCallback',
  handleSet_gsRoster: 'handleSet_gsRoster',
  handleSet_parentKeyCollectionItems: 'handleSet_parentKeyCollectionItems',
  handleSet_seasonMatchesForBackup: 'handleSet_seasonMatchesForBackup',
  handleSet_sidebar: 'handleSet_sidebar',
  handleSet_sportsInfo: 'handleSet_sportsInfo',
  handleSet_sportsInfoAndResults: 'handleSet_sportsInfoAndResults',
  handleSet_sportsRealtimeResultsInfo: 'handleSet_sportsRealtimeResultsInfo',
  handleSet_sportsResultsInfo: 'handleSet_sportsResultsInfo',
  handleSet_sportsSeasonData: 'handleSet_sportsSeasonData',
  handleSet_sportsSeasonState: 'handleSet_sportsSeasonState',
  handleSet_tempSelectedSeason: 'handleSet_tempSelectedSeason',
  handleShow_sportsElem: 'handleShow_sportsElem',
  handleUpdate_sportsSeasonSubData: 'handleUpdate_sportsSeasonSubData',
  handleUpdate_sportsSeasonTs: 'handleUpdate_sportsSeasonTs',
  ...grts,
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const sportsSeasonReducer = (state, action) => {

  const {
    appUserAccess,
    currents,
    currentSidebars,
    gameScoringType,
    matches_info,
    teams_info,
    results_matchDay,
    results_realtime,
  } = state

  const { matches, matches_playoffs } = matches_info ?? {}
  const { type, dispatch, sportsKey: sports_key } = action

  // const state = {
  //   history: {
  //     '2A': []
  //   },
  //   matches: {
  //     'matchKey1': { matchData: {} },
  //     'matchKey2': { matchData: {} },
  //   },
  //   playoffMatches: {
  //     'matchKey1': { matchData: {isPlayoff: true} },
  //     'matchKey2': { matchData: {isPlayoff: true} },
  //   },
  //   rankings: {
  //     'week1': {
  //       '2A': ['team1', 'team2'],
  //       '3A': ['team1', 'team2']
  //     }
  //   },
  //   scheduleDates: {
  //     '6': ['date1', 'date2'],
  //     '7': ['date1', 'date2'],
  //   },
  //   teams: {
  //     'teamKey1': {},
  //     'teamKey2': {}
  //   }
  // }

  switch (type) {

    case rts.handleSet_sportsInfoAndResults:
      const { sportsData } = action
      const _newState = ammendState_sportsInfo(sportsData?.sportInfo, state)
      if (sportsData?.sportsResultsInfo?.matchInfo_seasonal) {
        const matches_groupInfo = getMatches_groupInfo(sportsData?.sportsResultsInfo?.matchInfo_seasonal, _newState.selectedSeason, null, appUserAccess)
        const _state_withResults = ammendState_sportsResults(matches_groupInfo, _newState, _getScoresFromScores)
        return _state_withResults
      }
      return { ...state }

    case rts.handleSet_sportsInfo:
      const { sportInfo } = action
      const _state_withInfo = ammendState_sportsInfo(sportInfo, state)
      return _state_withInfo

    case rts.handleSet_sportsResultsInfo:
      const { sportsResultsInfo } = action
      const { matchInfo_seasonal } = sportsResultsInfo ?? {}
      // matchInfo_seasonal => matches, playoffMatches...
      if (matchInfo_seasonal) {
        console.log('matchInfo_seasonal', matchInfo_seasonal)
        console.log('teams_info', teams_info)
        const matches_groupInfo = getMatches_groupInfo(matchInfo_seasonal, state.selectedSeason, null, appUserAccess)
        const _state_withResults = ammendState_sportsResults(matches_groupInfo, state, _getScoresFromScores)
        return _state_withResults
      }
      return { ...state }

    case rts.handleSet_sportsRealtimeResultsInfo:
      const { sportsRealtimeResultsInfo } = action
      const { matchDayResults, realtimeResults } = sportsRealtimeResultsInfo ?? {}
      realTimeScoring.ammendRealtimeResults(realtimeResults, gameScoringType)
      realTimeScoring.ammendRealtimeResults(matchDayResults, gameScoringType)
      return { ...state, results_realtime: realtimeResults, results_matchDay: matchDayResults }

    // case rts.handle_testSeason:
    // console.log('state', state?.matches_info?.matches?.['2WAoKdCy3O4fz9ZmVzFt'])
    // const _matches_info = _.cloneDeep(matches_info)
    // _matches_info.TEST = 'Test'
    // if (_matches_info?.matches_groupInfo?.levelMatches?.['6A']?.['2WAoKdCy3O4fz9ZmVzFt']) {
    //   const vbm = _matches_info?.matches_groupInfo?.levelMatches?.['6A']?.['2WAoKdCy3O4fz9ZmVzFt']
    //   vbm.results.score.home = 100
    //   matchCalcs.calcVballMatch(vbm)
    //   console.log('vbm', vbm)
    // }
    // return { ...state, matches_info: _matches_info }

    case rts.handleSet_accessTeams:
      return { ...state, access_teams: action.sportsAccess }

    case rts.handleSet_tempSelectedSeason:
      return { ...state, tempSelectedSeason: action.tempSelectedSeason }

    case rts.handleSet_databaseCallback:
      return { ...state, [action.dataType]: action.data }

    case rts.handleAmmend_playoffQualifyCounts:
      return { ...state, details_info: { ...state.details_info, playoffQualifyCounts: action.playoffQualifyCounts } }

    // triggered by changes to realtimeResults or matchDayResults from useEffect in SportsSeasonContext
    case rts.handleAmmend_seasonMatchesFromDbResults:
      // const { realtimeDocumentType } = action
      // if (matches_info) {
      //   switch (realtimeDocumentType) {
      //     case realtimeDocumentTypes.matchDay:
      //       sportsHelpers.ammendMatchesFromDbResults(results_matchDay, matches_info, realtimeDocumentType, gameScoringType)
      //       matches_info.matches_matchDay = results_matchDay ?? {}
      //       const results_matchDay_updates = seasonalHelpers.getResultsFromMatchDay(results_matchDay, matches, matches_playoffs)
      //       return { ...state, matches_info: matches_info, results_matchDay_updates }
      //     case realtimeDocumentTypes.realtime:
      //       sportsHelpers.ammendMatchesFromDbResults(results_realtime, matches_info, realtimeDocumentType, gameScoringType)
      //       matches_info.matches_realtime = results_realtime ?? {}
      //       return { ...state, matches_info: matches_info }
      //     default:
      //       return state
      //   }
      // }
      return state

    case rts.handleSet_seasonMatchesForBackup:

      const { data_pure: dp, matches_groupInfo: matches_data_sm, gameScoringType: gameScoringType_sm } = action
      const { data_pure: dpp } = dp ?? {}
      const { matches: matches_dpp } = dpp ?? {}
      const { data: matches_data } = matches_dpp ?? {}
      const { matches: matches_season } = matches_data ?? {}
      const { matchDateGroups: matchDateGroups_sm, dataResult_sm } = matches_data_sm ?? {}
      const { matchDateKeys: matchDateKeys_sm, matchDateKeys_count: matchDateKeys_count_sm } = sportsHelpers.getMatchDateKeys(matchDateGroups_sm)

      matchCalcs.calcAllVballMatches(matches_season, gameScoringType_sm)
      matchCalcs.calcAllVballMatches_displays(matches_season)

      const amm_sm = sportsHelpers.ammendMatchesInfo(matches_season)

      return {
        ...state,
        seasonMatches_info: {
          matchDateGroups: matchDateGroups_sm,
          matchDateKeys_count: matchDateKeys_count_sm,
          matchDateKeys: matchDateKeys_sm,
          matches: amm_sm.matches,
        }
      }

    case rts.handleSet_currentHistory:
      return { ...state, selectedHistory: action.selectedHistory }

    case rts.handleSet_sportsSeasonState:
      const { groupProp, stateProp } = action
      if (groupProp) {
        const _groupProp = state[groupProp] ? state[groupProp] : {}
        _groupProp[stateProp] = action.value
        return { ...state, [groupProp]: _groupProp }
      } else {
        return { ...state, [stateProp]: action.value }
      }

    case rts.handleSet_sportsSeasonData:
      if (action && action.ssData) {
        console.log('action.ssData', action.ssData)
      }
      return { ...state }

    case rts.handleUpdate_sportsSeasonTs:
      return { ...state, timestamp: new Date() }

    case rts.handleUpdate_sportsSeasonSubData:
      return { ...state, [action.subDataType]: action.subData }

    case rts.handleSet_sidebar:
      const crts = { ...currents }
      const crtsbrs = { ...currentSidebars }
      crts[action.clickType] = action.selected
      crtsbrs[action.sbItemType] = action.selected
      return { ...state, currents: crts, currentSidebars: crtsbrs }

    case rts.handleGoTo_team:
      const { team } = action
      const { id, _itemKey } = team ?? {}
      const teamKey = _itemKey ? _itemKey : id
      if (teamKey) {
        // action.pushSimple({ key: 'teams' }, teamKey) 
        action.navigation_fns.handleNav_item({ key: 'teams' }, teamKey)
        return { ...state, currentTeam: action.team }
      } else {
        return { ...state }
      }

    case rts.handleGoTo_match:
      // action.navigation_fns.handleNav_item(action.clickedItem, action.itemKey, action.modifyMode, action.opts, action.ddn, action.ddProps, action.ddGroupIndex)
      return { ...state, match_edit: matches ? matches[action.itemKey] : null }

    case rts.handleSet_parentKeyCollectionItems:
      const { collectionName, data_sportsCollectionItem } = action.d
      return { ...state, [collectionName]: data_sportsCollectionItem }


    case rts.handleSet_gsRoster:
      if (action.team) {
        return { ...state, ['roster_gs_' + action.team]: action.roster_gs }
      } else {
        return { ...state, roster_gs: action.roster_gs }
      }


    case rts.handleAmmend_mediaMatches:
      return { ...state, matchResultsInfo: action.matchResultsInfo }

    case rts.handleAmmend_teamsAccess:
      const _sportsAccess_sports = state.sportsAccess_teams
      _sportsAccess_sports.teams = action.access_teams
      return { ...state, sportsAccess_teams: _sportsAccess_sports }

    case rts.handleResponse_updateMatch:
      return { ...state, sportsShowType: null }

    case rts.handleShow_sportsElem:
      const { options } = action
      const { sportsShowType } = options ?? {}
      return { ...state, sportsShowType, sportsShowOptions: options }

    case rts.handleAmmend_sportCompares:
      return { ...state, sportCompares: { ...action.value } }

    case rts.handleFilter_sports:
      return { ...state, sportFilter: action.sf }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation }, { gsMatchedRefreshed: false })


    default:
      return { ...state }
  }
}

export const sportsSeasonHandlers = (dispatch) => {
  return {
    // handle_testSeason: () => { dispatch({ type: rts.handle_testSeason, dispatch }) },
    handleAmmend_mediaMatches: (matchResultsInfo) => { dispatch({ type: rts.handleAmmend_mediaMatches, dispatch, matchResultsInfo }) },
    handleAmmend_playoffQualifyCounts: (playoffQualifyCounts) => { dispatch({ type: rts.handleAmmend_playoffQualifyCounts, dispatch, playoffQualifyCounts }) },
    handleAmmend_seasonMatchesFromDbResults: (realtimeDocumentType) => { dispatch({ type: rts.handleAmmend_seasonMatchesFromDbResults, dispatch, realtimeDocumentType }) },
    handleAmmend_sportCompares: (value) => { dispatch({ type: rts.handleAmmend_sportCompares, dispatch, value }) },
    handleAmmend_teamsAccess: (access_teams) => { dispatch({ type: rts.handleAmmend_teamsAccess, dispatch, access_teams }) },
    handleDataResults_parentKeyCollections: (data_pure, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey) => { dispatch({ type: rts.handleDataResults_parentKeyCollections, dispatch, data_pure, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey }) },
    handleFilter_sports: (sf) => { dispatch({ type: rts.handleFilter_sports, dispatch, sf }) },
    handleGoTo_match: (pushSimple, clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex) => { dispatch({ type: rts.handleGoTo_match, dispatch, pushSimple, clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex }) },
    handleGoTo_team: (navigation_fns, team) => { dispatch({ type: rts.handleGoTo_team, dispatch, navigation_fns, team }) },
    handleResponse_updateMatch: (matchProps) => { dispatch({ type: rts.handleResponse_updateMatch, dispatch, matchProps }) },
    handleSet_accessTeams: (sportsAccess) => { dispatch({ type: rts.handleSet_accessTeams, dispatch, sportsAccess }) },
    handleSet_currentHistory: (selectedHistory) => { dispatch({ type: rts.handleSet_currentHistory, dispatch, selectedHistory }) },
    handleSet_databaseCallback: (data, dataType) => { dispatch({ type: rts.handleSet_databaseCallback, dispatch, data, dataType }) },
    handleSet_gsRoster: (matches_gs, team) => { dispatch({ type: rts.handleSet_gsRoster, dispatch, matches_gs, team }) },
    handleSet_parentKeyCollectionItems: (d) => { dispatch({ type: rts.handleSet_parentKeyCollectionItems, dispatch, d }) },
    handleSet_seasonMatchesForBackup: (data_pure, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey) => { dispatch({ type: rts.handleSet_seasonMatchesForBackup, dispatch, data_pure, sportsSeason_data, sportsSeason_data, matches_groupInfo, parentDataKeys, sportsKey }) },
    handleSet_sidebar: (clickType, selected, sidebarType, sbItemType) => { dispatch({ type: rts.handleSet_sidebar, dispatch, clickType, selected, sidebarType, sbItemType }) },
    handleSet_sportsInfo: (sportInfo) => { dispatch({ type: rts.handleSet_sportsInfo, dispatch, sportInfo }) },
    handleSet_sportsInfoAndResults: (sportsData) => { dispatch({ type: rts.handleSet_sportsInfoAndResults, dispatch, sportsData }) },
    handleSet_sportsRealtimeResultsInfo: (sportsRealtimeResultsInfo) => { dispatch({ type: rts.handleSet_sportsRealtimeResultsInfo, dispatch, sportsRealtimeResultsInfo }) },
    handleSet_sportsResultsInfo: (sportsResultsInfo) => { dispatch({ type: rts.handleSet_sportsResultsInfo, dispatch, sportsResultsInfo }) },
    handleSet_sportsSeasonData: (ssData) => { dispatch({ type: rts.handleSet_sportsSeasonData, dispatch, ssData }) },
    handleSet_sportsSeasonState: (value, stateProp, groupProp) => { dispatch({ type: rts.handleSet_sportsSeasonState, dispatch, value, stateProp, groupProp }) },
    handleSet_tempSelectedSeason: (tempSelectedSeason) => { dispatch({ type: rts.handleSet_tempSelectedSeason, dispatch, tempSelectedSeason }) },
    handleShow_sportsElem: (options) => { dispatch({ type: rts.handleShow_sportsElem, dispatch, options }) },
    handleUpdate_sportsSeasonSubData: (subDataType, subData) => { dispatch({ type: rts.handleUpdate_sportsSeasonSubData, dispatch }) },
    handleUpdate_sportsSeasonTs: () => { dispatch({ type: rts.handleUpdate_sportsSeasonTs, dispatch }) },
    ...responseHandlers(dispatch),
  }
}

export const sportsSeasonInitialState = (init_state) => {
  return {
    ...init_state,
    currents: {},
    currentSidebars: {},
    _shows_sports: {},
  }
};

const ammendSportAccess = (drs) => {
  const { sportsAccess_teams, gls_teams } = drs ?? {}
  const access = {
    ...sportsAccess_teams,
  }
  const settings = {
    ...gls_teams,
  }

  return { access, settings }
}

/**
 * combines the current state with the sportInfo object
 * @param {*} asProps 
 * @returns 
 */
const ammendState_sportsInfo = (sportInfo, state) => {

  const _sportInfo = _.cloneDeep(sportInfo)

  // gls_teams 
  // history 
  // mediaFeeds 
  // rankings_seasonal 
  // seasonals 
  // sportsAccess_teams 
  // teamRosters_seasonal 
  // teams_seasonal 
  // teamStaff 
  // tournaments 

  const {
    gls_teams,
    history,
    mediaFeeds,
    parentDataKeys,
    rankings,
    seasonals,
    sport, // main doc
    sportMode, // derived from page
    sportsAccess_teams,
    teamRosters_seasonal,
    teams_seasonal,
    teamStaff,
    tournaments,
  } = _sportInfo ?? {}

  const { latestSeason, id: sportsKey } = sport ?? {}
  const { teams } = teams_seasonal ?? {}

  // ignore teams
  const { details, scheduleDates, sectionDates, sportsSettings, playoffQualifyCounts } = seasonals ?? {}

  const _sections = teams ? _.groupBy(teams, 'sections') : null

  let sectionPlayoffTeams = playoffQualifyCounts //{}
  const _rankings = rankings ? rankings : null

  const _state_ammended = {
    currentSeason_info: {
      latestSeason: latestSeason,
      latestSeason_full: latestSeason ? (latestSeason - 1) + '-' + latestSeason : latestSeason,
      currentSeason: latestSeason,
      ...sportMode,
      sportsKey,
      parentDataKeys,
    },
    history_info: {
      history: history,
      teams: sportsHelpers.getTeamHistories(teams, history)
    },
    media_info: {
      mediaFeeds,
    },
    teams_info: {
      teams: teams,
      rosters: teamRosters_seasonal,
      staff: teamStaff,
      playoffTeams: teams && sportsHelpers.getPlayoffTeams(teams),
      sectionKeys: _sections ? Object.keys(_sections).sort() : [],
    },
    tournaments_info: {
      tournaments: tournaments,
    },
    rankings_info: {
      rankings: _rankings,
      lastestRanking: sportsHelpers.getLastestRankings(_rankings)
    },
    seasonal_info: {
      scheduleDates,
      sectionDates,
      seasonReady: true,
      sportsSettings,
    },
    details_info: {
      details: details,
      sectionPlayoffTeams,
      playoffQualifyCounts: {
        4: 2,
        5: 4,
        6: 4,
        7: 4,
        8: 4,
        9: 4,
      }
    },
    googleLinks_info: {
      gls_teams: gls_teams
    },
    sportsAccess_teams: {
      teams: sportsAccess_teams ? { ...sportsAccess_teams.teams } : {},
    },
    gls_teams: gls_teams ? { ...gls_teams } : {},
    sportsSeason_datas: _sportInfo,
  }


  const newState = _.merge({}, state, _state_ammended);
  return newState
}

/**
 * combines the existing state with matches_info
 * @param {object} asProps 
 * @returns 
 */
const ammendState_sportsResults = (matches_groupInfo, state, _getScoresFromScores) => {

  const { currentSeason_info, teams_info, _sportSeasonSettings } = state ?? {}
  const { gameScoringType, _sportsModeSport } = currentSeason_info ?? {}
  const { teams: teams_seasonal } = teams_info ?? {}
  const { startHour } = _sportSeasonSettings ?? {}

  const {
    levelLatestStartDates,
    selectedSeason: _selectedSeason,
    playoffTournaments,
  } = matches_groupInfo ?? {}

  const { matches_info, _teamsFromMatches, upcomingMatchDate, amm, ssi } = ammendMatchesAndTeams(
    matches_groupInfo,
    teams_seasonal,
    teams_info,
    gameScoringType,
    _getScoresFromScores,
    levelLatestStartDates,
    startHour,
    _sportsModeSport
  )

  const playoff_info = {
    playoffTournaments: playoffTournaments ? playoffTournaments : null,
  }

  const _matches_state = {
    playoff_info,
    seasonal_info: {
      sportLevels: ssi?.sportLevels,
      totalWeeks: amm?.totalWeeks,
      firstMatchDate: amm?.firstMatchDate,
      lastMatchDate: amm?.lastMatchDate,
    },
    teams_info: {
      _teamsFromMatches,
    },
    upcomingMatchDate,
    matches_info
  }

  const newState = {
    ...state,
    ..._matches_state,
    teams_info: {
      ...teams_info,
      teams: ssi?.teams,
    }
  }

  // if (newState?.teams_info?.teams && newState?.matches_info?.matches) {
  //   const t = newState.teams_info?.teams
  //   const m = newState.matches_info?.matches
  //   const r = newState?.rankings_info?.rankings
  //   const spt = {} // sectionPlayoffTeams
  //   sportsHelpers.ammendTeams(t, m, r, _sportsModeSport, spt)
  // }

  return newState
}

// const testData = async (database_fns, pathViews, spreadsheetId) => {
//   const gsi = '17wW4AqQOkVkHTAQ9ttl__AIQQhHadfVf4OppcAZSkLg'
//   const eventRef = createRefPath_event(pathViews, ['_gls_scores'])
//   const wheres = []
//   // wheres.push(where('parentKeys.districts', '==', pathViews.districts))
//   // wheres.push(where('gls_scores.googleSheetsId', '==', gsi))
//   const docs = await database_fns.get_data({ refPath: eventRef, wheres })
//   if (docs) {
//     _.forEach(docs, (doc) => {
//       const { gls_scores } = doc ?? {}
//       if (gls_scores) {
//         const x = _.find(gls_scores, { 'googleSheetsId': gsi })
//         console.log('x', x)
//       }
//     })
//   }

// }

// const notifyAppUsers = (database_fns, match_edit) => {
//   const { teams: teams_match } = match_edit ?? {}
//   const cbn = (nr) => {
//     console.log('nr', nr)
//   }
//   const cb = (appUser) => {
//     if (appUser) {
//       const { fcmTokens, _itemKey } = appUser ?? {}
//       if (fcmTokens) {
//         const _fcmTokens = []
//         _.forEach(fcmTokens, (fcmToken, key) => {
//           const { tokenKey } = fcmToken ?? {}
//           if (tokenKey) {
//             _fcmTokens.push(tokenKey)
//           }
//         })
//         if (_fcmTokens.length > 0) {
//           const notificationData = {
//             title: 'Match Update',
//             body: 'Some Match Results for you',
//           }
//           fn_cls.sendNotificationByData(notificationMethodTypes.firebaseApi, notificationData, {}, _fcmTokens, null, null, null, null, cbn, _itemKey)
//         }
//       }
//     }
//     console.log('res', appUser)
//   }
//   const refPath = createRefPath(['profiles'])
//   const wheres = []
//   wheres.push(where('pageFavz', 'array-contains-any', teams_match))
//   database_fns.get_data({ refPath, wheres, callback: cb, opts: { returnFirstObject: true } })
// }

// const getDataSizes = (sportsSeason_data, matches_groupInfo) => {

//   const jsonDatas = {
//     sports: JSON.stringify(sportsSeason_data),
//     matches: JSON.stringify(matches_groupInfo),
//   }

//   const sizes = {
//     sports: new Blob([jsonDatas.sports]).size,
//     matches: new Blob([jsonDatas.matches]).size,
//   }

//   const gSizes = {
//     sports: sizes.sports / 1048576,
//     matches: sizes.matches / 1048576,
//   }

//   console.log('gSizes', gSizes)
// }